import fetch from "auth/FetchInterceptor";

const AuthService = {};

AuthService.login = function (data) {
  return fetch({
    url: "/auth/login",
    method: "post",
    data: data,
  });
};

AuthService.register = function (data) {
  return fetch({
    url: "/auth/register",
    method: "post",
    data: data,
  });
};

AuthService.signUpEmailRequest = function (data) {
  return fetch({
    url: "/auth/register",
    method: "post",
    data: data,
  });
};

AuthService.signInEmailRequest = function (email, password) {
  return fetch({
    url: "/auth/login",
    method: "post",
    data: {
      email,
      password,
    },
  });
};

AuthService.forgetPasswordRequest = function (data) {
  return fetch({
    url: "/auth/forgotpassword",
    method: "post",
    data: data,
  });
};

export default AuthService;
